import React, { useContext, useEffect, useState } from 'react'
import './style.css'
import { InlineIcon } from '@iconify/react/dist/iconify.js'
import { PrivilegeContext } from '../../../context/PrivilegesContext'
import { DomainContext } from '../../../context/DomainContext'
import { Block } from '../../crRender'
import { useTranslation } from 'react-i18next'

const ReportHeader = ({ children, ExportTemplateFile, ActionName, ApplyAction, ExportExcel, customAction, customActionName, title }) => {
    const { t } = useTranslation()
    const [exportLoading, setExportLoading] = useState(false)
   
    const { setToggleSearch, searchArea, searchData, customSearchData } = useContext(DomainContext)
   
    const { privileges } = useContext(PrivilegeContext)

    useEffect(() => {
        return () => setToggleSearch(true)
    }, [])

    useEffect(() => {
        if (!exportLoading) return;
        ExportExcel?.({ ...searchData, ...customSearchData })?.then((res) => {
            setExportLoading(false)
        }).catch((_) => {
            setExportLoading(false)
        })
    }, [exportLoading])

    return (
        <div className='user-actions-section'
        style={{
            overflow: searchArea ? "visible" : "hidden"
        }}>
            <div className={`header-section ${title && "justify-content-between" } mb-0`}>
              {title &&  <p className="text-capitalize title mb-0">{t("Search")} {t(title)}</p>}
                <div className='user-actions'>
                    <Block onClick={customAction} isRender={!!customAction} tooltipName={customActionName || ActionName}>
                        <InlineIcon icon={"heroicons:adjustments-vertical-16-solid"} className={`Icon `} />
                    </Block>

                    <Block onClick={ApplyAction} isRender={!!(privileges?.canAdd && ApplyAction)} tooltipName={ActionName}>
                        <InlineIcon icon={"gridicons:add-outline"} className={`Icon `} />
                    </Block>

                    <Block onClick={ExportTemplateFile} isRender={!!(ExportTemplateFile && privileges?.canGet)} tooltipName={"file-template"}>
                        <InlineIcon icon={"vscode-icons:file-type-excel"} className='Icon' />
                    </Block>

                    <Block isRender={!!(ExportExcel)} onClick={() => setExportLoading(true)} tooltipName={"export"}>
                        <InlineIcon icon={"solar:file-download-linear"} className='Icon' />
                    </Block>

                    <Block onClick={() => setToggleSearch(!searchArea)} tooltipName={"Search"}>
                        <InlineIcon icon={"hugeicons:filter-reset"} className={`Icon seacrh-section-icon  ${searchArea ? "tables-search" : ""}`} />
                    </Block>
                </div>
            </div>
            <div className='search-search'>
                {children}
            </div>
        </div >
    )
}

export default ReportHeader